/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dev-tool.vue?vue&type=template&id=768f9546&scoped=true&"
import script from "./dev-tool.vue?vue&type=script&lang=js&"
export * from "./dev-tool.vue?vue&type=script&lang=js&"
import style0 from "./dev-tool.vue?vue&type=style&index=0&id=768f9546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768f9546",
  null
  
)

export default component.exports